import { CalendarDayButton } from './calendar_day_button';
import { CalendarHead } from './calendar_head';
import { CalendarNav } from './calendar_nav';
/**
 * Component overrides for the react-day-picker calendar
 */
export const calendarComponents = {
    // Overrides the Month / Year, Previous and Next Navigation
    Caption: CalendarNav,
    // Overrides the way that the day of the week renders
    Head: CalendarHead,
    // Overrides the way that days are rendered
    Day: CalendarDayButton,
    // Overrides the footer element to support explicitSave / Cancel actions
    // Footer: (props: FooterProps) => <>footer for actions</>,
};
//# sourceMappingURL=calendar_components.js.map